import { useCallback } from 'react';

import { getCommerceBillingUiPorts } from '../../settings/billing/billing-ui-ports';
import {
  resolveEvidenceUpgradeModalTarget,
  type EvidenceUpgradeModalTarget,
} from './resolveEvidenceUpgradeModalTarget';

export type OpenEvidenceUpgradeModalOptions = {
  isScribePlusUser: boolean;
  isClinicianTrialUser: boolean;
  isPracticeUpgradeTarget: boolean;
};

export function useOpenEvidenceUpgradeModal() {
  const setClinicianUpgradeModalOpen =
    getCommerceBillingUiPorts().useSetClinicianUpgradeModalOpen();
  const setPracticeUpgradeModalOpen =
    getCommerceBillingUiPorts().useSetPracticeUpgradeModalOpen();

  const openModalForTarget = useCallback(
    (target: EvidenceUpgradeModalTarget) => {
      switch (target) {
        case 'clinician':
          setClinicianUpgradeModalOpen(true);
          break;
        case 'practice':
          setPracticeUpgradeModalOpen(true);
          break;
      }
    },
    [setClinicianUpgradeModalOpen, setPracticeUpgradeModalOpen]
  );

  const openEvidenceUpgradeModal = useCallback(
    ({
      isScribePlusUser,
      isClinicianTrialUser,
      isPracticeUpgradeTarget,
    }: OpenEvidenceUpgradeModalOptions) => {
      const target = resolveEvidenceUpgradeModalTarget({
        isScribePlusUser,
        isClinicianTrialUser,
        isPracticeUpgradeTarget,
      });
      openModalForTarget(target);
    },
    [openModalForTarget]
  );

  return { openEvidenceUpgradeModal };
}
